goog.provide("shadow.js.shim.module$$mui$material$Drawer");
goog.provide("module$shadow_js_shim_module$$mui$material$Drawer");
shadow.js.shim.module$$mui$material$Drawer = shadow.js.nativeProvides["@mui/material/Drawer"] = shadow$bridge("@mui/material/Drawer");
module$shadow_js_shim_module$$mui$material$Drawer.default = shadow.js.shim.module$$mui$material$Drawer;
